import { render, staticRenderFns } from "./AddColumnRight.vue?vue&type=template&id=0877d778&"
import script from "./AddColumnRight.vue?vue&type=script&lang=js&"
export * from "./AddColumnRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports